import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import {
  useAddFTPConfig,
  useFTPConfigById,
  useUpdateFTPConfig,
} from "../hook/useFTPImportBatches";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { showToast } from "../../../utils/toastUtils";
import { Spinner } from "reactstrap";

interface FtpConfigModalContentProps {
  handleClose?: () => void;
  mode?: any;
  selectedRow?: any;
}

const FtpConfigModalContent: React.FC<FtpConfigModalContentProps> = ({
  handleClose,
  mode,
  selectedRow,
}) => {
  const [username, setUsername] = useState("");
  const [port, setPort] = useState("");
  const [pass, setPass] = useState("");
  const [host, setHost] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: SingleFtpConfig, isLoading } =
    useFTPConfigById({
      enable: mode === "edit" && !!selectedRow,
      params: { ftpConfigId: selectedRow?.FtpConfigId },
    });

  const { mutate: addftpconfig } = useAddFTPConfig();
  const { mutate: updateftpconfig } = useUpdateFTPConfig();

  useEffect(() => {
    if (mode === "edit" && SingleFtpConfig?.data?.FTPConfigData) {
      setPass(SingleFtpConfig.data.FTPConfigData.Password || "");
      setHost(SingleFtpConfig.data.FTPConfigData.Host || "");
      setPort(SingleFtpConfig.data.FTPConfigData.Port || "");
      setUsername(SingleFtpConfig.data.FTPConfigData.Username || "");
    }
  }, [mode, SingleFtpConfig]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;

    // Validations
    if (!host) return showToast.warning("Host is required");
    if (!username) return showToast.warning("Username is required");
    if (!pass) return showToast.warning("Password is required");
    if (!port) return showToast.warning("Port is required");

    const payload: any = {
      host: host,
      username: username,
      password: pass,
      port: port,
    };

    setIsSubmitting(true);

    if (mode === "edit" && selectedRow?.FtpConfigId) {
      payload.ftpConfigId = selectedRow.FtpConfigId;
      updateftpconfig(payload, {
        onSuccess: () => {
          handleClose?.();
          setIsSubmitting(false);
        },
        onError: (err: any) => {
          console.error(err);
          setIsSubmitting(false);
        },
      });
    } else {
      addftpconfig(payload, {
        onSuccess: () => {
          handleClose?.();
          setIsSubmitting(false);
        },
        onError: (err: any) => {
          console.error(err);
          setIsSubmitting(false);
        },
      });
    }
  };

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
        {/* <span className="ms-3">Loading SGPI Brands...</span> */}
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <CustomInput
        asterisk
        required
        placeholder="Enter Host"
        label="Host"
        value={host}
        type="text"
        onChange={(e) => setHost(e.target.value)}
      />
      <CustomInput
        asterisk
        required
        placeholder="Enter Username"
        label="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <CustomInput
        asterisk
        required
        placeholder="Enter Password"
        label="Password"
        value={pass}
        onChange={(e) => setPass(e.target.value)}
      />
      <CustomInput
        placeholder="Enter Port"
        label="Port"
        value={port}
        type="number"
        onKeyDown={(e) => {
          if (e.key === "-" || e.key === "e") e.preventDefault();
        }}
        onWheel={(e) => e.currentTarget.blur()}
        onChange={(e) => setPort(e.target.value)}
      />
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          disabled={isSubmitting}
        >
          {mode === "edit"
            ? isSubmitting
              ? "Updating..."
              : "Update"
            : isSubmitting
            ? "Submitting..."
            : "Submit"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default FtpConfigModalContent;
